import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import TextInputWrapper from './text-input-wrapper'
import CheckboxWrapper from './checkbox-wrapper'

function FormModal({regions, onClose, onCreate}) {
  const [title, setTitle] = useState('')
  const [titleError, setTitleError] = useState(null)
  const [message, setMessage] = useState('')
  const [messageError, setMessageError] = useState(null)
  const [selectedRegions, setSelectedRegions] = useState([])
  const [regionsError, setRegionsError] = useState(null)
  const presenceError = "Can't be blank"

  const onRegionChange = (e) => {
    const id = Number(e.target.value)
    const checked = e.target.checked
    const newRegions = checked ? selectedRegions.concat(id) : selectedRegions.filter(item => item != id)
    setSelectedRegions(newRegions)
  }

  const onSelectAll = (e) => {
    setSelectedRegions(e.target.checked ? allRegions() : [])
  }

  const allRegions = () => {
    return regions.map(r => r.id).sort()
  }

  const allRegionsSelected = () => {
    return _.isEqual(selectedRegions.sort(), allRegions())
  }

  const onSubmit = (e) => {
    e.preventDefault()

    const [validTitle, validMessage, validRegions] = [!_.isEmpty(title.trim()), !_.isEmpty(message.trim()), !_.isEmpty(selectedRegions)]
    validTitle ? setTitleError(null) : setTitleError(presenceError)
    validMessage ? setMessageError(null) : setMessageError(presenceError)
    validRegions ? setRegionsError(null) : setRegionsError(presenceError)

    if (validTitle && validMessage && validRegions) onCreate({ title: title, message: message, region_ids: selectedRegions })
  }

  return (
    <Modal container={document.body} show={true} onHide={onClose} dialogClassName='push-notifications-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Send a push notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className='form-horizontal' onSubmit={onSubmit}>
          <TextInputWrapper
            label='Title'
            value={title}
            placeholder='Title'
            onChange={(e) => setTitle(e.target.value)}
            error={titleError}
          />
          <TextInputWrapper
            label='Message'
            value={message}
            placeholder='Message'
            onChange={(e) => setMessage(e.target.value)}
            error={messageError}
          />
          <div className='row'>
            <div className='col-sm-12'>
              <label className='pn-regions-title'>Regions</label>
            </div>
            <div className='col-sm-12'>
              <CheckboxWrapper
                label='Select All'
                value='All'
                checked={allRegionsSelected()}
                onChange={onSelectAll}
              />
            </div>
            <div className='col-sm-12'>
              {
                regions.map((region, index) => {
                  return <CheckboxWrapper 
                    key={index}
                    label={region.name}
                    value={region.id}
                    checked={selectedRegions.includes(region.id)}
                    onChange={onRegionChange}
                    error={regionsError}
                  />
                })
              }
            </div>
            <div className='col-sm-12 text-center'>
              <input type='submit' value='Send' className='btn btn-success' />
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

FormModal.propTypes = {
  regions: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
}

export default FormModal

